import * as parse from 'date-fns/parse';
/**
 * Globally set the amount of time to delay before removing the disabled class.
 */
export var disabledClickDelay = 3000;
/**
 * Return the ps window adapter if cookies are not found.
 */
export var getCookieAdapter = function (cookie) {
    if (window.ps && window.ps.adapt && window.ps.adapt.getInfo) {
        return window.ps.adapt.getInfo()[cookie];
    }
    return getCookie(cookie);
};
/**
 * Return a cookie value by name or null if not found
 */
export var getCookie = function (k) {
    var cookieValue = (' ' + document.cookie).match(RegExp('[; ]' + k + '=([^\\s;]*)'));
    if (k && cookieValue != null) {
        if (cookieValue[1]) {
            return cookieValue[1];
        }
        else {
            hermesLog('error', 'NULL value', 'Empty cookie ' + k);
        }
    }
    else {
        hermesLog('warn', 'NOT FOUND', 'Missing cookie ' + k);
    }
};
/**
 * Fire the name event at the window
 */
export var dispatchGlobalEvent = function (eventName, eventVal) {
    var customEvent;
    if (typeof CustomEvent === 'function') {
        customEvent = new CustomEvent(eventName, { detail: eventVal });
        customEvent = window.dispatchEvent(customEvent);
    }
    else {
        customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(eventName, true, true, { detail: eventVal });
        customEvent = window.dispatchEvent(customEvent);
    }
    return customEvent;
};
/**
 * Replace characters in a string with the values specified.
 */
export var sprintf = function (text, values) {
    var items = [];
    return text.replace(/%(\d+)(%%)?/g, function (value, index, percentage) {
        var result = values[index];
        if (percentage) {
            result += '%';
        }
        items.push(result); // TODO: undefined check
        return items.shift();
    });
};
/**
 * Convert all numbers using the separators returned from the ps-i18n module.
 */
export var numberSeparator = function (num, digit, decimal) {
    // first need to convert everything to en format.
    return num
        .toLocaleString('en')
        .replace(/\./g, '_TEMP_')
        .replace(/,/g, digit)
        .replace(/_TEMP_/g, decimal);
};
export var newLine = function (text, cut) {
    var chunks = text.split(cut);
    console.log('CHUNKS: ', chunks);
    var zero = chunks[0] + ':';
    var one = chunks[1];
    return [zero, one];
};
/**
 * Return a boolean if the context condition is met.
 */
export var inContext = function (context) {
    var checkValues = new RegExp(context, 'i');
    return checkValues.test(document.querySelector('[stars-rewards]').getAttribute('stars-rewards'));
};
/**
 * Return a boolean if the current device is a mobile device.
 */
export var isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
};
export function formatExpiresOnTime(time, timezone, lang) {
    var dateLocale = parse(time).toLocaleDateString(lang, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
    return dateLocale + " " + timezone;
}
/**
 * Send errors to hermes if present.
 */
export var hermesLog = function (messageType, err, description) {
    var componentKey = __HERMES_COMPONENT_KEY__;
    var componentVersion = __VERSION__;
    console.log('[HERMES REPORTER] ' +
        messageType +
        ' ' +
        JSON.stringify({
            message: description + ': ' + err,
            componentKey: componentKey,
            componentVersion: componentVersion,
        }));
    if (window && window.hermes) {
        try {
            hermes(messageType, {
                message: description + ': ' + err,
                componentKey: componentKey,
                componentVersion: componentVersion,
            });
        }
        catch (error) {
            console.log(error);
        }
    }
};
